export function isNullOrUndefined(val: Date | string | undefined | null): boolean {
    return val === undefined || val === null || val === '';
}